import { tv } from "@utils/tw"
import { BlogTileFragment } from "@generated-types"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Chip } from "@components/ui/Chip"
import { formatNiceDate } from "@utils/date-format"
import { Link } from "eddev/routing"
import { Button } from "@components/ui/Button"

type Props = BlogTileFragment

export function BlogPostTile(props: Props) {
  const styles = createStyles()

  return (
    <Link className={styles.base()} href={props.uri!}>
      <div className={styles.image()}>
        <ResponsiveImage {...props.info?.heroImage} aspect={16 / 9} />
        <div className={styles.meta()}>
          <Chip shape="rounded" variant="mid">
            {formatNiceDate(props.dateGmt!)}
          </Chip>
          {props.info?.category?.name && (
            <Chip shape="rounded" variant="mid">
              {props.info?.category?.name}
            </Chip>
          )}
        </div>
      </div>
      <div className={styles.title()}>{props.title}</div>
      <div className={styles.excerpt()} dangerouslySetInnerHTML={{ __html: props.excerpt! }} />
      <div className={styles.buttonContainer()}>
        <Button aria-hidden shape="default" variant="primary" className="w-full">
          Read more
        </Button>
      </div>
    </Link>
  )
}

const createStyles = tv({
  base: "group flex flex-col relative isolate h-full hover-card",
  slots: {
    image: "relative overflow-hidden group-hover:rounded-md transition-[border-radius] duration-150",
    meta: "absolute bottom-3 left-3 gap-2 md:bottom-2 md:left-2 md:gap-1 flex pointer-events-none",
    title: "type-label-m mt-3 mb-2 text-fg",
    excerpt: "type-body-s line-clamp-3 text-fg-secondary",
    buttonContainer:
      "mt-4 hidden md:flex flex-grow justify-stretch items-end opacity-0 group-hover:opacity-100 transition-opacity duration-150",
  },
})
